import enhance from './enhancer';
import MyBrandsEdit from './MyBrandsEdit';

export default enhance(MyBrandsEdit);
